

const Header = ({ title }) => <h1>{ title }</h1>;

export default Header;